import React from 'react';
import { Box, Typography } from '@mui/material';
import '../Docs.css'
export default function ConfiguringAirtable() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>Configuring Your Data Source: Airtable</Typography>
      <Typography paragraph>
        Connect an Airtable account under Integrations → Airtable. Once linked, Airtable appears among your data sources.
      </Typography>
      <Typography paragraph>
Select your base from the dropdown menu. Its tables will then load into the corresponding selection field. Once you choose a table and PostSheet fetches the data, the <strong>Next</strong> button will become available.      </Typography>
      <img src='../../static/docs/SelectAirtableBase.jpg' className="step-img"/>
      {/* TODO: Add screenshot of Airtable base/table selection */}
    </Box>
  );
}